<template>
  <b-card :title="$t('loggedOutTitle')">
    <b-card-text>
      <b><b-link href="/">{{ $t('loggedOutText') }}</b-link></b>
    </b-card-text>
  </b-card>
</template>
<script>

  export default {
    name: 'LogOut'
  }
</script>
